import clsx from "clsx";
import { type ReactNode } from "react";

import { Clock } from "@/features/clock/clock";

import * as styles from "./header.css";

type HeaderProps = {
  left?: ReactNode;
  right?: ReactNode;
} & CommonProps;

export function Header({
  "data-testid": dataTestId = "header",
  className,
  left,
  right,
  style,
}: HeaderProps): ReactNode {
  return (
    <div
      style={style}
      className={clsx(styles.root, className)}
      data-testid={dataTestId}
    >
      <div className={styles.slot}>{left}</div>
      <div className={clsx(styles.slot, styles.rightSlot)}>
        {right}
        <Clock className={styles.clock} />
      </div>
    </div>
  );
}
